import React from 'react'
import { Spring, config } from 'react-spring/renderprops.cjs'
import StoryOverlayContent from './storyOverlayContent'
import StoryOverlayNavigation from './storyOverlayNavigation'
import Close from '/img/svg/close'
import Menu from '/img/svg/menu'
import { isTablet } from '/js/util'

class StoryOverlay extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isMobileNavigationOpen: false,
      selectedNavigationSectionIndex: null
    }

    this.childSections = new Map()
  }

  handleNavigationClick = index => {
    this.setState({
      selectedNavigationSectionIndex: index,
      isMobileNavigationOpen: false
    })
  }

  openMobileNavigation() {
    this.setState({ isMobileNavigationOpen: true })
  }

  closeMobileNavigation() {
    this.setState({ isMobileNavigationOpen: false })
  }

  renderControls = () => {
    const { isMobileNavigationOpen } = this.state
    const { handleClose } = this.props
    const isMenuOpen = isTablet() && isMobileNavigationOpen

    return (
      <div
        data-label="overlay-controls"
        className="absolute right-7 top-7 z-10 flex flex-col"
      >
        <button
          className="mb-10 hover:scale-150 transition-fast"
          onClick={
            isMenuOpen
              ? () => this.closeMobileNavigation()
              : () => handleClose()
          }
        >
          <Close />
          <span className="screenreader">Close</span>
        </button>
        {isTablet() && (
          <Spring
            to={{
              opacity: isMenuOpen ? 0 : 1,
              width: isMenuOpen ? 0 : 'auto',
              visibility: isMenuOpen ? 'hidden' : 'visible'
            }}
          >
            {props => (
              <button
                className="hover:scale-150 transition-fast"
                style={props}
                onClick={() => this.openMobileNavigation()}
              >
                <Menu />
                <span className="screenreader">Open Menu</span>
              </button>
            )}
          </Spring>
        )}
      </div>
    )
  }

  render() {
    const {
      isMobileNavigationOpen,
      selectedNavigationSectionIndex
    } = this.state
    const {
      story,
      theme,
      icon,
      title,
      handleClose,
      selectedCardSectionIndex,
      selectedCardCardIndex
    } = this.props

    return (
      <div className="lg:flex flex-row-reverse h-full">
        {this.renderControls()}
        <StoryOverlayNavigation
          handleNavigationClick={this.handleNavigationClick}
          cards={story.cards}
          theme={theme}
          icon={icon}
          title={title}
          handleClose={handleClose}
          isMobileNavigationOpen={isMobileNavigationOpen}
          closeMobileNavigation={this.closeMobileNavigation}
        />
        <StoryOverlayContent
          story={story}
          theme={theme}
          title={title}
          selectedCardSectionIndex={selectedCardSectionIndex}
          selectedCardCardIndex={selectedCardCardIndex}
          selectedNavigationSectionIndex={selectedNavigationSectionIndex}
          sectionNodes={this.childSections}
        />
      </div>
    )
  }
}

export default StoryOverlay
